import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/customer-api/trade-reports/pageExt', params)

// 新增
export const add = params =>
  // add
  request.post('/customer-api/trade-reports/trade/exportExt', params, {
    responseType: 'blob',
  })

// 下载
export const download = params =>
  request.get(`/customer-api/file/download`, params, { responseType: 'blob' })

// 查询
export const search = params =>
  request.post(`/customer-api/trade-reports/page`, params)

export const getMultiValueList = params => {
  if (typeof params === 'string') params = { typeMark: params }
  return request.post('/masterdata-api/valuelist/getMultiValueList', params)
}
